import React from 'react';
import { connect } from 'react-redux';
// import MasterCard from '../../assets/svg/MasterCard';
// import Visa from '../../assets/svg/Visa';
import mastercardicon from '../../../assets/images/mastercard.svg';
import visaicon from '../../../assets/images/visa.svg';
class CartPaymentInfoItem extends React.Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="profile-info-wrapper">
                <div className="information-wrapper">
                    <div className="payment-row">
                        <a 
                            onClick={this.props.onButtonPress}
                        >
                            <div className="credit-card-info">
                                <div className="card-card-logo-wrapper">  
                                    <img src={mastercardicon}  className="credit-card-logo-icon" />
                                    <img src={visaicon}  className="credit-card-logo-icon" />
                                </div>
                                <div className="card-info-wrapper">
                                    <p>{this.props.title}</p>
                                </div>
                            </div>
                        </a>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {

    return {
        user: state.auth.user,
        token: state.auth.token
    };
};

export default connect(mapStateToProps)(CartPaymentInfoItem);
